import React, { useEffect, useRef, useState } from 'react';
import { Outlet } from 'react-router-dom';
import TopNavBar from '../components/user/TopNavBar';

function UserLayout({ children }) {
  const [headerVisible, setHeaderVisible] = useState(true);
  const [scrolled, setScrolled] = useState(false);
  const lastScrollY = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;
      setHeaderVisible(currentY < lastScrollY.current || currentY < 10);
      setScrolled(currentY > 10);
      lastScrollY.current = currentY;
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen font-sans bg-background text-font-primary">
      <TopNavBar visible={headerVisible} scrolled={scrolled} />
      <main className="w-full mt-16 m-auto max-w-8xl lg:px-4 py-6">
        {children || <Outlet />}
      </main>
    </div>
  );
}

export default UserLayout;
